import Joi from 'joi';

export const ProvinceSchema = Joi.object({
  name: Joi.string().required(),
  englishName: Joi.string().required(),
  iso: Joi.string().required(),
  isSpecialEconomicZone: Joi.boolean().required()
});
